import {Action} from "redux";
import {GetCustomersByClientTopPageRequest} from "../request/customer_request";
import {GetCustomersByClientTopPageResponse} from "../response/customer_response";

export enum ClientTopPageActionType {
    REQUEST_GET_CUSTOMERS = "CLIENT_TOP_PAGE_REQUEST_GET_CUSTOMERS",
    CALLBACK_GET_CUSTOMERS = "CLIENT_TOP_PAGE_CALLBACK_GET_CUSTOMERS",
}

export interface IRequestGetCustomersByClientTopPageAction extends Action {
    type: ClientTopPageActionType.REQUEST_GET_CUSTOMERS;
    item: GetCustomersByClientTopPageRequest;
}

export interface ICallbackGetCustomersByClientTopPageAction extends Action {
    type: ClientTopPageActionType.CALLBACK_GET_CUSTOMERS;
    isSuccess: boolean;
    item?: GetCustomersByClientTopPageResponse;
}

export type ClientTopPageAction =
    IRequestGetCustomersByClientTopPageAction |
    ICallbackGetCustomersByClientTopPageAction
;

export interface IClientTopPageActionCreator {
    requestGetCustomersByClientTopPageAction(
        item: GetCustomersByClientTopPageRequest
    ): IRequestGetCustomersByClientTopPageAction;

    callbackGetCustomersByClientTopPageAction(
        isSuccess: boolean,
        items?: GetCustomersByClientTopPageResponse,
    ): ICallbackGetCustomersByClientTopPageAction;

}

class ActionCreator implements IClientTopPageActionCreator {

    public requestGetCustomersByClientTopPageAction = (
        item: GetCustomersByClientTopPageRequest
    ): IRequestGetCustomersByClientTopPageAction => {
        return {
            type: ClientTopPageActionType.REQUEST_GET_CUSTOMERS,
            item,
        }
    }

    public callbackGetCustomersByClientTopPageAction = (
        isSuccess: boolean,
        item?: GetCustomersByClientTopPageResponse
    ): ICallbackGetCustomersByClientTopPageAction => {
        return {
            type: ClientTopPageActionType.CALLBACK_GET_CUSTOMERS,
            isSuccess,
            item,
        }
    }
}

export const createClientTopPageActionCreator = (): IClientTopPageActionCreator => {
    return new ActionCreator();
}


// WEBPACK FOOTER //
// ./src/presentation/action/client_top_page_action.ts